import React from "react";
import { QuizFunnel } from "./components/QuizFunnel";
export function App() {
  return <QuizFunnel data-id="element-0" data-mp="35ckb29dc16k1" />;
}